"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MorningStarInc = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var GlobalParameter_1 = require("../../GlobalParameter");
var MorningStarInc = (function (_super) {
    __extends(MorningStarInc, _super);
    function MorningStarInc() {
        return _super.call(this, {
            name: CardName_1.CardName.MORNING_STAR_INC,
            tags: [Tags_1.Tags.VENUS],
            startingMegaCredits: 50,
            cardType: CardType_1.CardType.CORPORATION,
            initialActionText: 'Draw 3 Venus-tag cards',
            metadata: {
                cardNumber: 'R06',
                description: 'You start with 50 M€. As your first action, reveal cards from the deck until you have revealed 3 Venus-tag cards. Take those into hand and discard the rest.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(50).nbsp.cards(3, { secondaryTag: Tags_1.Tags.VENUS });
                    b.corpBox('effect', function (ce) {
                        ce.effect('Your Venus requirements are +/- 2 steps, your choice in each case.', function (eb) {
                            eb.plate('Venus requirements').startEffect.text('+/- 2');
                        });
                    });
                }),
            },
        }) || this;
    }
    MorningStarInc.prototype.initialAction = function (player) {
        player.drawCard(3, { tag: Tags_1.Tags.VENUS });
        return undefined;
    };
    MorningStarInc.prototype.getRequirementBonus = function (_player, parameter) {
        return parameter === GlobalParameter_1.GlobalParameter.VENUS ? 2 : 0;
    };
    MorningStarInc.prototype.play = function () {
        return undefined;
    };
    return MorningStarInc;
}(Card_1.Card));
exports.MorningStarInc = MorningStarInc;
